/*
**************************************************************************
Title:          Users service
Created By:     Pankaj Arora
Created on:     05/02/2018
Description:    This is a user service publishes stream for current & bot user
**************************************************************************
*/
import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subject, BehaviorSubject } from 'rxjs';
import { User } from './user.model';

@Injectable()
export class UserService {
  // `currentUser` contains the current user
  currentUser: Subject<User> = new BehaviorSubject<User>(null);
  botUser: Subject<User> = new BehaviorSubject<User>(null);

  constructor() {
    // hardcoded for testing
    const botUser = new User('Esme');
    this.botUser.next(botUser);

    const currentUser = new User('Guest');
    this.currentUser.next(currentUser);

  }

  public setCurrentUser(newUser: User): void {
    this.currentUser.next(newUser);
  }

  public setBotUser(newUser: User): void {
    this.botUser.next(newUser);
  }

}

export const userServiceInjectables: Array<any> = [
  UserService
];
